// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

/**
 * How use it:
 * 1. by dispatch:
 *      dispatch({ type: "xDealers/update", data: { key: "isStick", value: true } });
 *      data => it has "key" -> object key and value
 * 2. by handler:
 *      xDealersUpdate({ key: "isStick", value: true });
 */

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export type xDealersStateType = Readonly<{
    industriesDataView: {
        isLoading?: boolean;
        industries?: string[];
    };
}>;

export const initialDealersState: xDealersStateType = {
    industriesDataView: {
        isLoading: false,
        industries: undefined,
    },
};

const reducer = {
    "xDealers/BeginLoadDealersIndustries": (draft: Draft<xDealersStateType>, action: { collection: string[] }) => {
        draft.industriesDataView.isLoading = true;
    },
    "xDealers/CompleteLoadDealersIndustries": (draft: Draft<xDealersStateType>, action: { collection: string[] }) => {
        draft.industriesDataView.isLoading = false;
        draft.industriesDataView.industries = action.collection;
    },
};

const xDealers = createTypedReducerWithImmer(initialDealersState, reducer);

(reducers as any).xDealers = xDealers;

export type xDealersState = {
    xDealers: xDealersStateType;
} & ApplicationState;

type xDealersReducers = {
    [key: string]: typeof xDealers;
};

export type xDealersActions = Parameters<xDealersReducers[keyof xDealersReducers]>[1] | AnyAction;
